import Vue from 'vue';

// Prefered: as a plugin (directive + filter) + custom placeholders support
import VueMask from 'v-mask';
Vue.use(VueMask);
